import * as React from 'react';

class AutoComplete extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      currentText: '',
      filteredValues: [],
      currentSelection: undefined,
      selIndex: 0,
      showList: false,
      previousValue: '',
      forceDropdown: false,
      lastBlur: undefined,
      avLength: undefined,
    };

    this.onEditAutoComplete = this.onEditAutoComplete.bind(this);
    this.onBlurAutoComplete = this.onBlurAutoComplete.bind(this);
    this.onKeyDown = this.onKeyDown.bind(this);
    this.onClickAutoComplete = this.onClickAutoComplete.bind(this);
    this.onFocus = this.onFocus.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.toggleMenu = this.toggleMenu.bind(this);
  }

  componentDidMount() {
    if (this.props.allowedValues) {
      let node = this.props.allowedValues.find(
        (f) => f[this.props.valueField] === this.props.value
      );

      let textVal = '';
      if (node && this.props.value !== null) {
        textVal = node[this.props.displayField];
      } else {
        textVal = this.props.value;
      }

      if (textVal === null || textVal === undefined) textVal = '';
      this.setState({
        currentText: textVal,
        currentValue: this.props.value,
        avLength: this.props.allowedValues.length
      });
    }
  }

  componentWillUnmount() {}

  // static getDerivedStateFromProps(props, state) {
  //   if (props.value !== state.currentValue) {
  //     return {
  //       currentText: props.value,
  //       currentValue: props.value,
  //     };
  //   }
  //   return null;
  //   //this.setState({currentText: props.fieldValue})
  // }

  componentDidUpdate() {
    if (this.props.value === 0 && this.state.currentText === 0) {
      this.setState({ currentText: '' });
    }
    let avChange = false;
    if(this.state.avLength !== this.props.allowedValues.length)
    {
      this.setState({avLength: this.props.allowedValues.length});
      avChange = true;
    }
    if (
      (this.props.value !== this.state.currentValue || avChange ) &&
      this.props.allowedValues
    ) {
      let node = this.props.allowedValues.find(
        (f) => f[this.props.valueField] === this.props.value
      );

      let textVal = '';
      if (node && this.props.value !== null) {
        textVal = node[this.props.displayField];
      } else {
        textVal = this.props.value;
      }

      if (textVal === null) textVal = '';
      this.setState({
        currentText: textVal,
        currentValue: this.props.value,
      });
    }
  }

  onEditAutoComplete(e) {
    let filter = [];
    let val = e.target.value;
    for (let i = 0; i < this.props.allowedValues.length; i++) {
      if (
        this.props.allowedValues[i][this.props.displayField]
          .toLowerCase()
          .includes(val.toLowerCase())
      ) {
        filter.push(this.props.allowedValues[i]);
      }
    }
    let sindex = 0;
    if (filter.length > 0) {
      let sel = filter[0];
      this.setState({
        selIndex: sindex,
        currentSelection: sel,
        showList: true,
      });
    } else {
      this.setState({
        selIndex: 0,
        currentSelection: null,
        showList: false,
        forceDropdown: false,
      });
    }

    if(this.props.enforce === 'false' && this.props.onChange)
    {
      this.props.onChange(val);
    }

    //this.props.updateValue(e.target.value, this.props.fieldId, this.props.systemName);
    this.setState({
      currentText: e.target.value,
      filteredValues: filter,
    });
  }

  onClickAutoComplete(e, sel) {
    this.setState({
      currentText: sel[this.props.displayField],
      showList: false,
    });
    if (this.props.onChange) {
      this.props.onChange(sel[this.props.valueField]);
    }
    //this.props.closeAllList();
    //this.tabNext(inp);
    e.preventDefault();
  }

  onBlurAutoComplete(e) {
    if (this.state.currentText !== '') {
      let sel = this.state.currentSelection;
      if (
        sel !== null &&
        sel !== undefined &&
        sel.hasOwnProperty(this.props.displayField) &&
        this.state.showList
      ) {

        this.setState({
          currentText: sel[this.props.displayField],
          showList: false,
          lastBlur: new Date(),
        });
        if (this.props.onChange) {
          this.props.onChange(sel[this.props.valueField]);
        }
      }
      if (sel === null || sel === undefined) {
        //sel = { id: this.state.currentText, value: this.state.currentText };
        //if (this.props.onChange && this.props.enforce !== 'true') {
        //  this.props.onChange(e.target.value);
        //}
      }
    } else {
      this.props.onChange('');
    }
    if(this.state.showList)
    {
      this.setState({ showList: false, lastBlur: new Date() });
    }
    //
  }

  onFocus(e) {
    if (this.props.setFocus !== null && this.props.setFocus !== undefined) {
      this.props.setFocus(this.props.id);
    }

    let fullList = this.props.allowedValues;
    if (fullList) {
      this.setState({ showList: true, filteredValues: [...fullList] });
    }

    e.target.select();
  }

  onKeyDown(e) {
    if (e.keyCode === 13) {
      //var form = e.target.form;
      let sel = this.state.currentSelection;
      this.setState({
        currentText: sel[this.props.displayField],
        showList: false,
      });
      if (this.props.onChange) {
        this.props.onChange(sel[this.props.valueField]);
      }
      e.preventDefault();
    }

    // up
    if (e.keyCode === 38) {
      let sindex = this.state.selIndex;
      sindex--;
      if (sindex >= 0) {
        this.setState({
          currentSelection: this.state.filteredValues[sindex],
          selIndex: sindex,
          showList: true,
        });
      }
      e.preventDefault();
    }
    // down
    if (e.keyCode === 40) {
      let sindex = this.state.selIndex;
      sindex++;
      if (sindex < this.state.filteredValues.length) {
        this.setState({
          currentSelection: this.state.filteredValues[sindex],
          selIndex: sindex,
          showList: true,
        });
      }
      e.preventDefault();
    }
  }

  onMouseEnter(e, sel) {
    this.setState({ currentSelection: sel });
  }

  toggleMenu() {
    if(this.state.showList === false)
    {
      let txtId = `${this.props.id}_text`;
      let input = document.getElementById(txtId);
      let now = new Date();
      let preventBlur = false;
      if(this.state.lastBlur !== undefined){

        let diff = Math.floor(now.getTime() - this.state.lastBlur.getTime());
        if(diff < 250) preventBlur = true;
      }

      if(this.state.filteredValues.length === 0)
      {
        let fullList = this.props.allowedValues;
        if (fullList) {
          this.setState({ showList: true, filteredValues: [...fullList] });
        }
      }
      if(!preventBlur)
      {
        input.select();
      }
      //input.focus();
      //this.setState({showList: true});
    } else {
      this.setState({showList: false});
    }
  }

  render() {
    return (
      <div style={{ position: 'relative' }}>
        <div id={this.props.id} className='autocomplete'>
          <div className='input-group'>
          <input
            id={`${this.props.id}_text`}
            className='form-control autocomplete'
            value={this.state.currentText}
            autoComplete='off'
            onBlur={this.onBlurAutoComplete}
            onChange={this.onEditAutoComplete}
            onFocus={this.onFocus}
            disabled={this.props.disabled ? 'disabled' : ''}
            onKeyDown={this.onKeyDown}
            title={this.props.title}
          />
          <div className='input-group-append'>
            <button tabIndex={-1} style={{border: 'solid 1px #CCC'}} className='btn btn-light' onClick={this.toggleMenu} ><i className='fa-solid fa-chevron-down' /></button>
          </div>
          </div>
        </div>
        {this.state.showList && (
          <div
            className='autocomplete-items'
            style={{ maxHeight: '200px', overflow: 'auto' }}
          >
            {this.state.filteredValues.map((sel) => (
              <div
                tabIndex='0'
                key={sel[this.props.valueField]}
                style={{
                  cursor: 'pointer',
                  backgroundColor:
                    sel === this.state.currentSelection ? '#E4EFFF' : '#fff',
                }}
                onMouseDown={(e) => this.onClickAutoComplete(e, sel)}
                onMouseEnter={(e) => this.onMouseEnter(e, sel)}
              >
                {sel[this.props.displayField]}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  }
}

export default AutoComplete;
